export const PROJECT_KEY = '001'
export const SECRET_KEY = '!atease@1234'
export const FCM_VAPID = 'BGFMRf2uCKXNDtUYhMlh5uPFS6X6iok6wI6o4ktPjPQp6kUqUkDgCZyYuZUp9n9iRJhXRRLgNsZrIkYXYvRTRW8'